import React from 'react'
import { Route } from 'react-router-dom'
import { lazyWithPreload } from './lazy-with-preload'
import { FeatureBoundary } from '../components/core/ErrorBoundary'

// Exported for `route-preload` — see `DashboardRoutes`.
export const SingleProject = lazyWithPreload(() =>
  import('../modules/Projects/containers/SingleProjectContainer')
)

export const projectRoutes = [
  <Route key='project-base' path='/project/:projectSlug' element={<FeatureBoundary feature='project'><SingleProject /></FeatureBoundary>} />,
  <Route key='project-feature' path='/project/:projectSlug/:featureName' element={<FeatureBoundary feature='project'><SingleProject /></FeatureBoundary>} />
]
